<template>
  <div>
    <button type="button" class="btn--secondary" data-test="back-button" @click="handleClick()">
      <slot />
    </button>
  </div>
</template>

<script>
import { ROUTES } from '@/constants'

export default {
  name: 'BackButton',
  props: {
    /**
     * The location descriptor object to be passed into vue-router replace
     * If none is provided, goes back to the previous page
     */
    location: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    modalVisible: false
  }),
  methods: {
    handleClick() {
      this.$emit('click')
      this.route()
    },
    route() {
      if (this.location && Object.values(ROUTES).includes(this.location.name)) {
        this.$router.replace(this.location)
      } else {
        this.$router.replace({ name: ROUTES.PROFILE_HOME })
      }
    }
  }
}
</script>
